import React from 'react'
import Layout from '../components/Layout.js'
import Button from '../components/Button.js'
import { APP_STORE_URL } from '../config.js'

const Home = () => {
  return (
      <Layout>
        <section>
          <div className="w-full text-center">
            <h1 className="text-gray-900 dark:text-white mx-auto mt-[70px] mb-[50px] text-[120px] tracking-[-6px] leading-[130px] font-extrabold max-md:text-[42px] max-md:leading-[60px] max-md:tracking-[-2px] max-md:mx-auto max-md:mt-[30px] max-md:mb-[50px] md:max-lg:text-[100px] md:max-lg:leading-[130px] md:max-lg:tracking-[-6px] md:max-lg:mx-auto md:max-lg:mt-[30px] md:max-lg:mb-[50px]">
              <span className='text-gradient from-gray-700 dark:from-gray-50 to-gray-500 dark:to-gray-300 pl-1.5 pr-1.5 mb-[-10px]'>Social Podcasting via</span>
              <div>
                <span className="text-gradient from-purple-600 to-pink-600 pl-1.5 pr-1.5 mb-[-10px]">Podcast Index & AT Protocol</span>
              </div>
              
            </h1>
            <p className="m-auto mt-0 text-[22px] font-normal text-gray-600 dark:text-gray-500 max-w-3xl leading-[34px] py-0 px-4 max-sm:text-[16px] max-sm:leading-[26px] sm:max-md:text-[18px] sm:max-md:leading-[28px] sm:max-md:max-w-xl">
              Effem for iOS: search the open podcast index, subscribe, download, and talk about episodes with
              the identity you already own.
              {APP_STORE_URL ? ' Available now on the App Store.' : ' Coming to the App Store.'}
            </p>
            <div className="mt-[40px] flex flex-wrap justify-center items-center gap-6">
              {APP_STORE_URL && (
                <a
                  href={APP_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group h-12 leading-12 rounded-lg transition duration-300 ease-in-out text-white dark:text-black bg-gray-800 dark:bg-gray-300 shadow-2xl"
                >
                  <span className="h-full px-8 flex items-center justify-center rounded-lg">
                    Download on the App Store
                  </span>
                </a>
              )}
              <Button text="Learn More" link="/about" variant="primary" />
              <Button text="Contact Us" link="/contact" variant="gradient" shadow={true} />
            </div>
          </div>
        </section>
      </Layout>
  )
}

export default Home
